import * as ExifReader from "exifreader"
import Clipboard from "clipboard"
import "bootstrap-star-rating"
// It's not possible (or i did not find any other way) to use select2 and bootstrap-datetimepicker
// from node_modules. They will not be populated to the global jQuery object.
import "../vendor/select2"
import "../vendor/bootstrapDateTimePicker"

import { currentLocale } from "./locale"
import { arrayUniq } from "./utils"

export const initDatePickerNavigation = (
  elem = $("[data-date-picker-navigation='true']"),
) => {
  const locale = currentLocale()
  const localeFormat = locale === "en-ca" ? "DD/MM/YYYY" : "L" // we map "en" to "en-ca"

  const picker = $("[data-picker-input]", elem).datetimepicker({
    locale: locale,
    format: localeFormat,
    widgetPositioning: {
      horizontal: "left",
      vertical: "bottom",
    },
    ignoreReadonly: true,
    focusOnShow: false,
    allowInputToggle: true,
  })

  picker.clickedOutside = (e) => {
    picker.data("DateTimePicker").hide()
  }

  picker.on("dp.hide", (_) => {
    $(document).off("mousedown touchend", picker.clickedOutside)
  })

  picker.on("dp.show", (_) => {
    $(document).on("mousedown touchend", picker.clickedOutside)
  })

  $(document).on("dp.change", picker, function (_) {
    elem.submit()
  })

  // Prevent datepicker from being opened when next / prev date buttons are pressed.
  $("[data-date-navigation-link]", elem).on("click", function (e) {
    e.stopPropagation()
    const anchor = e.target as HTMLAnchorElement
    location.href = anchor.href
  })
}

export const initDatePicker = (elem = $(".date-picker-input")) => {
  const group = elem.parents(".input-group")
  const node = group.length > 0 ? group : elem
  $(".clear-date-picker", node).on("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    elem.val("")
    elem.trigger("blur")
  })

  return node.datetimepicker({
    format: "L",
    locale: currentLocale(),
    allowInputToggle: true,
  })
}

export const initDatePickerManual = (elem = $(".date-picker-manual-input")) => {
  return elem.datetimepicker({
    format: "L",
    locale: currentLocale(),
  })
}

export const initTimeRangePicker = (target = undefined) => {
  target = target || $(".time-range-picker-input")

  var timePicker = target.datetimepicker({
    locale: currentLocale(),
    format: "LT",
    allowInputToggle: true,
    ignoreReadonly: true,
  })

  timePicker.on("dp.change", function () {
    var button = $(".clear-input", $(this))
    var input = $("input", $(this))

    if (input.val() === "") {
      button.hide()
    } else {
      button.show()
    }
  })

  timePicker.each(function () {
    var button = $(".clear-input", $(this))
    var input = $("input", $(this))

    button.on("mousedown touchend", () => {
      input.val("")
      button.hide()
    })

    if (input.val() !== "") {
      button.show()
    }
  })
}

export const initSensitiveInput = () => {
  $(".edit-sensitive-string-input").on("click", function () {
    var input = $(this).parent().parent().find('input[type="text"]')
    var currentState = input.attr("disabled")
    input.attr("disabled", (!currentState).toString())
  })
}

export const initSelect2Input = (scope = $("body")) => {
  const unlicensedBadge = (state: any) => {
    if (state.element?.dataset.unlicensed !== "true") return null

    return $("<span>", { class: "badge badge-danger ml-2", text: "unlicensed" })
  }
  const formatState = (state: any) => {
    const $state = $("<span>").text(state.text || "\u200B")
    const icon = state.element?.dataset.icon

    if (icon) {
      $state.prepend(
        `<img src="${icon}" style="width: 25px; margin-right: 4px; position: relative; bottom: 1px;" />`,
      )
    }

    const badge = unlicensedBadge(state)
    if (badge) $state.append(badge)

    return $state
  }
  const formatSelectionState = (state: any) => {
    const selectionUrl = state.element?.dataset.selectionUrl
    if (!selectionUrl) return formatState(state)

    const $selection = $("<a>", { href: selectionUrl, text: state.text }).on("mousedown click", (event) => {
      event.stopPropagation()
    })
    const badge = unlicensedBadge(state)
    if (badge) $selection.append(badge)

    return $selection
  }

  $.each($("[data-for-select2='true']", scope), function () {
    const elem = $(this)
    const width = elem.data("select2Width") ? elem.data("select2Width") : "100%"
    elem.select2({
      theme: "bootstrap4",
      width: width,
      templateSelection: formatSelectionState,
      templateResult: formatState,
    })
  })
}

export const initLocationHrefOnChange = () => {
  $("[data-location-href-on-change='true']").on("change", function () {
    window.location.href = $(this).val() as string
  })
}

export const initEditButton = () => {
  $(document).on("click", "[data-simple-changeset-edit]", function (e) {
    e.preventDefault()
    var target = $(this).data().simpleChangesetEdit
    var context = $("[data-simple-changeset-group=" + target + "]")
    $("[data-simple-changeset-static-value]", context).hide()
    $("[data-simple-changeset-input]", context).show()
    $(this).hide()
  })
}

export const initCopyValueOnChange = () => {
  $("[data-copy-value-on-change]").on("change", function () {
    let { target, override } = $(this).data().copyValueOnChange
    let targetNode = $(target)
    if (!targetNode.val() || override) {
      targetNode.val($(this).val())
    }
  })
}

export const initFileToDataUrlInput = () => {
  // see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
  var validTypes = ["image/gif", "image/jpeg", "image/png"]
  var size = 400
  var fileTypeValid = function (fileType) {
    return validTypes.indexOf(fileType) !== -1
  }

  var maxFileSize = 0.5
  var fileSizeValid = function (size) {
    return size <= maxFileSize
  }

  var createImage = function (data, input) {
    var img = new Image()
    $(img)
      .attr({
        src: data,
        class: "img-thumbnail to-data-url-image",
      })
      .appendTo($(input).parent().parent())
  }

  var clearImage = function (input) {
    $(input).parent().siblings(".img-thumbnail").remove()
  }

  var loadImage = function (event, self) {
    var file = self.files[0]

    if (!fileTypeValid(file.type)) {
      alert("invalid file type")
      return
    }

    var arrReader = new FileReader()
    var hiddenField = $(self).siblings("input[data-to-data-url-hidden]")
    hiddenField.val("")

    arrReader.onload = function () {
      var reader = new FileReader()
      reader.onloadend = function () {
        $(self).val("")
        var result = resizeImage(
          reader.result,
          arrReader.result,
          function (result) {
            clearImage(self)
            createImage(result, self)
            hiddenField.val(result)
          },
        )
      }
      reader.readAsDataURL(file)
    }
    arrReader.readAsArrayBuffer(file)

    var setOrientation = function (ctx, arrayBuffer) {
      if (file.type !== "image/jpeg") return

      var tags = ExifReader.load(arrayBuffer)
      var orientationTag = tags["Orientation"]
      if (!orientationTag) return

      var orientation = orientationTag.value
      if (!orientation || orientation > 8) {
        return
      }

      switch (orientation) {
        case 2:
          // horizontal flip
          ctx.translate(size, 0)
          ctx.scale(-1, 1)
          break
        case 3:
          // 180° rotate left
          ctx.translate(size, size)
          ctx.rotate(Math.PI)
          break
        case 4:
          // vertical flip
          ctx.translate(0, size)
          ctx.scale(1, -1)
          break
        case 5:
          // vertical flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.scale(1, -1)
          break
        case 6:
          // 90° rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.translate(0, -size)
          break
        case 7:
          // horizontal flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.translate(size, -size)
          ctx.scale(-1, 1)
          break
        case 8:
          // 90° rotate left
          ctx.rotate(-0.5 * Math.PI)
          ctx.translate(-size, 0)
          break
      }
    }

    var resizeImage = function (dataURL, arrayBuffer, callback) {
      var img = new Image()
      img.onload = function () {
        var imgWidth = img.width
        var imgHeight = img.height
        var width = 0
        var height = 0
        if (imgWidth > imgHeight) {
          height = size
          width = imgWidth / (imgHeight / size)
        } else {
          width = size
          height = imgHeight / (imgWidth / width)
        }
        var canvas = $("<canvas></canvas>").attr({
          width: width,
          height: height,
        })
        var canvasElem = canvas[0] as HTMLCanvasElement
        var ctx = canvasElem.getContext("2d")
        ctx.drawImage(img, 0, 0, width, height)

        var cropImg = new Image()
        cropImg.onload = function () {
          var cropCanvas = $("<canvas></canvas>").attr({
            width: size,
            height: size,
          })
          var cropCanvasElem = cropCanvas[0] as HTMLCanvasElement
          var cropCtx = cropCanvasElem.getContext("2d")
          setOrientation(cropCtx, arrayBuffer)
          cropCtx.drawImage(cropImg, 0, 0, size, size, 0, 0, size, size)
          callback.call(this, cropCanvasElem.toDataURL())
        }
        cropImg.src = canvasElem.toDataURL()
      }
      img.src = dataURL
    }
  }

  $("input[data-to-data-url='true']", "form").each(function (idx, item) {
    var hiddenField = $(item).siblings("input[data-to-data-url-hidden='true']")
    var val = $(hiddenField).val()
    if (val !== "") {
      createImage($(hiddenField).val(), item)
    }
  })

  $(document).on("change", "input[data-to-data-url='true']", function (e) {
    loadImage(e, this)
  })
}

export const initToggleWithString = () => {
  var showHide = function (node) {
    $.each(node, function (_, n) {
      if ($(n).is(":checked")) {
        $($(n).data("target"))
          .prop("disabled", false)
          .removeClass("disabled")
          .removeClass("d-none")
      } else {
        $($(n).data("target"))
          .prop("disabled", true)
          .addClass("disabled")
          .addClass("d-none")
      }
    })
  }

  $(".toggle-with-string-checkbox").on("click", function () {
    showHide($(this))
  })

  showHide($(".toggle-with-string-checkbox"))
}

export const initCustomFileInput = () => {
  $(".custom-file-input").on("change", function () {
    const val = $(this).val() as string
    var fileName = val.split("\\").pop()
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName)
  })
}

export const initInlineBoolean = () => {
  $("[data-inline-boolean]").prop("indeterminate", true)
}

export const initTagListInputSelect2 = (
  selector = $("[data-tag-list='true']"),
) => {
  $.each($(selector), function () {
    const elem = $(this)
    const width = elem.data("select2Width") ? elem.data("select2Width") : "100%"

    $(selector).select2({
      theme: "bootstrap4",
      tags: elem.data("forbid-new") != true,
      tokenSeparators: [",", " "],
      width,
    })
  })
}

export const initCopyableStringInput = () => {
  const node = $("[data-clipboard-target]")
  if (node.length === 0) return

  node.on("click", (e) => e.preventDefault())

  const clipboard = new Clipboard("[data-clipboard-target]")
  clipboard.on("success", function (e: any) {
    setTimeout(() => e.clearSelection(), 300)
  })
}

export const initGlobalizedFieldsLocaleBar = (scp = $("body")) => {
  const links = $("a", $('[data-toggle="globalized-inputs"]', scp))

  if (links.length < 1) return

  $.each($("[data-globalized-input-locale]", scp), function () {
    const wrapper = $(this)

    if (wrapper.data("globalizedCharCount")) {
      const field = $("textarea, input:not([type=hidden])", wrapper).first()

      $("[data-globalized-char-count]", wrapper).text(
        (field.val() as string).length,
      )

      field.on("propertychange input", function () {
        $("[data-globalized-char-count]", wrapper).text(
          ($(this).val() as string).length,
        )
      })
    }
  })

  links.on("click", function (e: Event) {
    e.preventDefault()

    const localeSelector = $(this)
    const locale = localeSelector.data("locale")

    links.removeClass("active")
    localeSelector.addClass("active")

    $("[data-globalized-input-locale]", scp).hide().removeClass("active")
    $(`[data-globalized-input-locale='${locale}']`, scp)
      .show()
      .addClass("active")
    $("[data-globalized-label-locale]", scp).text(locale)
  })
}

export const initClosureMatrix = () => {
  const activate = (cell: HTMLElement) => {
    $(cell).addClass("active")
    $("input[type=checkbox]", cell).prop("checked", true)
  }

  const deactivate = (cell: HTMLElement) => {
    $(cell).removeClass("active")
    $("input[type=checkbox]", cell).prop("checked", false)
  }

  $(".btn-matrix-col", ".btn-matrix-header-row").on("click", function (event) {
    event.preventDefault()
    const colIndex = $(this).index()
    const cells = $(".btn-matrix-body-row").map(
      (_, row: HTMLElement) => $(".btn-matrix-col", row).eq(colIndex)[0],
    )
    const colActive =
      cells.filter((_, cell: HTMLElement) => cell.classList.contains("active"))
        .length > 0
    cells.each((_, cell: HTMLElement) => {
      if (colActive) {
        deactivate(cell)
      } else {
        activate(cell)
      }
    })
  })
}

export const initShowSubmitOnChange = () => {
  $("[data-show-submit-on-change]").on("change", function () {
    const form = $(this).parents("form")
    $("[type=submit]", form).removeClass("d-none")
  })
}

export const initHighlightInput = () => {
  $("[data-highlight-input=true]").animate(
    {
      "background-color": "#28a745",
      opacity: 0.5,
    },
    "slow",
    function () {
      $("[data-highlight-input]").animate(
        {
          "background-color": "white",
          opacity: 1,
        },
        "slow",
      )
    },
  )
}

export const initSubmitOnChange = () => {
  $(document).on("change", "[data-submit-on-change]", function () {
    $(this).parents("form").trigger("submit")
  })
}

export const initReloadOnChange = () => {
  $(document).on("change", "[data-reload-on-change]", function () {
    const href = $(this).val() as string
    window.location.href = href
  })
}

export const initReloadOnChangeWith = () => {
  $(document).on("change", "[data-reload-on-change-with]", function () {
    const elems = $(
      "[data-reload-on-change-with]",
      $(this).parents("form"),
    ).toArray()
    const urls = arrayUniq(
      elems.map((item) => $(item).data("reloadOnChangeWith")["url"]),
    )
    if (urls.length > 1) {
      throw "all nodes with data-reload-on-change-with within the same form must have the same url configured."
    }

    const url = urls[0]
    const anchors = arrayUniq(
      elems.map((item) => $(item).data("reloadOnChangeWith")["anchor"]),
    )
    const anchor = anchors[0]
    const queryParams = elems
      .map((item) => {
        const { type } = $(item).data("reloadOnChangeWith")
        const val = $(item).val()
        if (val instanceof Array) {
          return val.map((v) => `${type}[]=${v}`).join("&")
        }
        return `${type}=${val}`
      })
      .join("&")

    let identifier = "?"
    if (url.match(/\?./)) {
      identifier = "&"
    }

    window.location.href = `${url}${identifier}${queryParams}${anchor || ""}`
  })
}

export const initColorInput = () => {
  $("input[data-color-input]").each(function () {
    $(this).val($(this).siblings("input[data-color-hidden-input]").val())
  })
  $(document).on("click", "[data-clear-color]", function (e) {
    e.preventDefault()
    var hiddenInput = $(this)
      .parent()
      .siblings("input[data-color-hidden-input]")
    var input = $(this).parent().siblings("input[data-color-input]")
    $(hiddenInput).val(null)
    $(input).val("#000000")
  })
  $(document).on("change", "[data-color-input]", function () {
    var value = $(this).val() as string
    var hiddenInput = $(this).siblings("input[data-color-hidden-input]")
    hiddenInput.val(value)
  })
}

type TemplatedAttributeData = {
  templated: boolean
  valueFromTemplate: string
  showTemplatedValue: boolean
}
export const initTemplatedInput = () => {
  $(document).on("input", "input[data-templated=true]", function () {
    const data = $(this).data() as TemplatedAttributeData
    const { valueFromTemplate } = data
    const value = $(this).val() as string
    if (value.length === 0) {
      $(this).val(valueFromTemplate)
      $(this).attr("data-show-template-value", "true")
    } else if (value === valueFromTemplate) {
      $(this).attr("data-show-template-value", "true")
    } else if (value !== valueFromTemplate) {
      $(this).attr("data-show-template-value", "false")
    }
  })
}

export const initToggleSwitch = () => {
  $(document).on("change", "input[data-toggle=toggle]", function (e) {
    e.preventDefault()
    const { url, method, target, remote, reloadOnSuccess } = $(this).data()
    if (target) {
      const currentVal = $(this)[0].checked
      $(target).val(currentVal)
    } else {
      $.ajax({
        url: url,
        method: method,
        dataType: remote === true ? "script" : "json",
      }).done(() => {
        if (reloadOnSuccess === true || reloadOnSuccess === "true")
          window.location.reload()
      })
    }
  })
}

export const initToggleCheckboxesGroup = () => {
  const parentCheckboxes = $("input[data-parent-toggler-of]")

  parentCheckboxes.each(function (_, pcb) {
    const toggledCheckboxesClass = $(pcb).data("parent-toggler-of")
    const allChildCheckboxes = $(`.${toggledCheckboxesClass}`)

    $(pcb).on("change", function (e) {
      e.preventDefault()

      allChildCheckboxes.each(function () {
        $(this).prop("checked", $(pcb).prop("checked"))
      })
    })

    allChildCheckboxes.each(function () {
      $(this).on("change", function (e) {
        e.preventDefault()

        if ($(this).prop("checked") == false) {
          $(pcb).prop("checked", false)
        } else {
          let allEnabled = true

          allChildCheckboxes.each(function () {
            allEnabled = allEnabled && $(this).prop("checked")
          })

          $(pcb).prop("checked", allEnabled)
        }
      })
    })
  })
}

export const initToggleOnChange = () => {
  $(document).on("change", "input[data-toggle-on-change]", function (e) {
    e.preventDefault()
    const { toggleOnChange } = $(this).data()
    $(toggleOnChange).toggleClass("d-none")
  })
}

export const initVisibilityControlOnChange = () => {
  $(document).on("change", "input[data-controls-visibility-of]", function (e) {
    e.preventDefault()
    const sourceCheckbox = $(this)
    const { controlsVisibilityOf, inverse } = sourceCheckbox.data()

    $(controlsVisibilityOf).each(function () {
      const targetDiv = $(this)
      const { visibilityControlledBy } = targetDiv.data()

      if (visibilityControlledBy) {
        let allControllingCheckboxesEnabled = true

        $(visibilityControlledBy).each(function () {
          const { inverse } = $(this).data()
          let enabled = this.checked || this.value === "true"

          if (inverse) enabled = !enabled
          allControllingCheckboxesEnabled &&= enabled
        })

        if (allControllingCheckboxesEnabled) {
          targetDiv.removeClass("d-none")
        } else {
          targetDiv.addClass("d-none")
        }
      } else {
        let enabled =
          sourceCheckbox[0].checked || sourceCheckbox[0].value === "true"
        if (inverse) enabled = !enabled

        if (enabled) {
          targetDiv.removeClass("d-none")
        } else {
          targetDiv.addClass("d-none")
        }
      }
    })
  })
}

export const initClearLinkedOnUncheck = () => {
  $(document).on("change", "input[data-clear-linked-on-uncheck]", function (e) {
    e.preventDefault()
    const { clearLinkedOnUncheck } = $(this).data()

    if (!$(this).is(":checked") && $(clearLinkedOnUncheck).is(":checked")) {
      $(clearLinkedOnUncheck).trigger("click")
    }
  })
}

export const initHttpsRequired = () => {
  // automatically add "https://" to all entered urls that don't contain a :
  $("[data-https-required]").blur(function () {
    const val = $(this).val() as string
    if (val.indexOf(":") == -1 && val.indexOf("//") == -1 && val != "") {
      $(this).val("https://" + val.trim())
      $(this).effect("highlight", {}, 1500)
    } else {
      $(this).val(val.trim())
    }
  })
}

const initSubmitAndRedirectToCreateAvailablity = () => {
  $(document).on(
    "click",
    "[data-submit-and-redirect-to-create-availability]",
    function (e: Event) {
      e.preventDefault()
      const { formSelector } =
        $(this).data().submitAndRedirectToCreateAvailability
      $("[data-redirect-to-create-availability-field]", formSelector).val(
        "true",
      )
      $("[name=submit]", formSelector).trigger("click")
    },
  )
}

const initLoadModal = () => {
  $(document).on("click", "[data-load-modal]", function (e: Event) {
    e.preventDefault()
    const href = $(this).attr("href")
    $.get(href, function (html) {
      $(html).modal("show")
    })
  })
}

const initDisableOnClick = () => {
  const initialTargetSelector = $("[data-disable-on-click]:not(:checked)").val()
  const initialTarget = $(`[data-disable-when='${initialTargetSelector}']`)
  if (initialTarget.is("a")) {
    initialTarget.addClass("disabled")
  } else {
    initialTarget.prop("disabled", true)
  }
  $(document).on("click", "[data-disable-on-click]", function (_) {
    const disableTargetSelector = $(this).data().disableOnClick
    $("[data-disable-when]").prop("disabled", false)
    $("[data-disable-when]").removeClass("disabled")
    const target = $(`[data-disable-when='${disableTargetSelector}']`)
    $(".invalid-feedback", target.parents(".has-error")).remove()
    target.parents(".has-error").removeClass("has-error")
    if (target.is("a")) {
      target.addClass("disabled")
    } else {
      target.prop("disabled", true)
    }
  })
}

export const initStringWithOptions = () => {
  $.each($(".string_with_options", $("body")), function () {
    const input = $(this)
    let dropdown = input.siblings(".dropdown-menu")
    input.on("focus", function () {
      dropdown.toggle()
    })
    dropdown.children(".dropdown-item").on("click", function () {
      input.val($(this).text())
      dropdown.hide()
    })
    input.on("input", function () {
      dropdown.hide()
    })
    input.on("change", function () {
      dropdown.hide()
    })
  })
}

const initStarRating = () => {
  if ($("input.star-rating").length === 0) return

  let stars = $("input.star-rating").data("stars") || 5
  $("input.star-rating").rating({
    min: 0,
    max: stars,
    step: 1,
    stars: stars,
    animate: false,
    showClear: false,
    showCaption: false,
    size: "xs",
  })
}

export const init = () => {
  initDatePickerNavigation()
  initTimeRangePicker()
  initDatePicker()
  initDatePickerManual()
  initSensitiveInput()
  initSelect2Input()
  initEditButton()
  initFileToDataUrlInput()
  initToggleWithString()
  initCustomFileInput()
  initInlineBoolean()
  initCopyableStringInput()
  initGlobalizedFieldsLocaleBar()
  initLocationHrefOnChange()
  initClosureMatrix()
  initShowSubmitOnChange()
  initHighlightInput()
  initSubmitOnChange()
  initColorInput()
  initTemplatedInput()
  initTagListInputSelect2()
  initToggleSwitch()
  initToggleOnChange()
  initVisibilityControlOnChange()
  initClearLinkedOnUncheck()
  initReloadOnChangeWith()
  initHttpsRequired()
  initSubmitAndRedirectToCreateAvailablity()
  initLoadModal()
  initReloadOnChange()
  initCopyValueOnChange()
  initDisableOnClick()
  initStringWithOptions()
  initStarRating()
  initToggleCheckboxesGroup()
}
